import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';

import { logError } from './helpers';

const triggerAuthModal = ({ action, flow }) => (options = {}) => {
    const { email, fireEntryGa = true, label, item, onSuccess, ...additionalOptions } = options;

    return authModalLoader
        .show({
            action,
            fireEntryGa,
            flow,
            email,
            ga: {
                label,
            },
            additionalProps: {
                item,
            },
            ...additionalOptions,
        })
        .then(res => {
            if (!res.err) {
                onSuccess({ userId: res.userId });
            }
        })
        .catch(e => {
            logError(`Authentication error: ${e.message}`);
        });
};

export const authModalFlows = authModalLoader.constants;
export const showLoginModal = triggerAuthModal({
    action: authModalFlows.LOGIN,
});
export const showRegisterModal = triggerAuthModal({
    action: authModalFlows.REGISTER,
});
export const designerConnectionLogin = triggerAuthModal({
    action: authModalFlows.LOGIN,
    flow: authModalFlows.DESIGNER_CONNECTION_MODAL_FLOW,
});
export const designerConnectionRegistration = triggerAuthModal({
    action: authModalFlows.REGISTER,
    flow: authModalFlows.DESIGNER_CONNECTION_MODAL_FLOW,
});
export const tradeAppLogin = triggerAuthModal({
    action: authModalFlows.LOGIN,
    flow: authModalFlows.TRADE_APPLICATION_FLOW,
});
export const tradeAppRegistration = triggerAuthModal({
    action: authModalFlows.REGISTER,
    flow: authModalFlows.TRADE_APPLICATION_FLOW,
});
export const favoriteItemLogin = triggerAuthModal({
    action: authModalFlows.LOGIN,
    flow: authModalFlows.SAVE_ITEM_FLOW,
});
